export default "__VITE_ASSET__CV3Bu0l3__"